import { cn } from "@/lib/utils";

export type VaultStatusKey = "Active" | "AtRisk" | "Finished" | "Liquidated";

const STATUS_STYLES: Record<
	VaultStatusKey,
	{ label: string; className: string }
> = {
	Active: {
		label: "Safe",
		className: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-300",
	},
	AtRisk: {
		label: "At risk",
		className: "bg-red-500/10 text-red-600 dark:text-red-300",
	},
	Finished: {
		label: "Finished",
		className: "bg-muted text-muted-foreground",
	},
	Liquidated: {
		label: "Closed",
		className: "bg-muted/60 text-muted-foreground",
	},
};

export function VaultStatusPill({
	status,
	className,
}: {
	status: VaultStatusKey;
	className?: string;
}) {
	const meta = STATUS_STYLES[status];
	return (
		<span
			className={cn(
				"inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wide",
				meta.className,
				className,
			)}
		>
			{meta.label}
		</span>
	);
}
